/** A tour's length (whole seconds on the wire) in words and back — the Schedule section's
 *  length slot (bus trips and exhibitions set it by hand). */

/** "1 d 2 h 30 min"; "—" for none. */
export function formatLength(value: unknown): string {
  if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) return '—';
  const days = Math.floor(value / 86400);
  const hours = Math.floor((value % 86400) / 3600);
  const minutes = Math.round((value % 3600) / 60);
  const parts = [days ? `${days} d` : '', hours ? `${hours} h` : '', minutes ? `${minutes} min` : ''].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : `${value} s`;
}

/** Hours and minutes as typed → whole seconds; null when empty, 'invalid' otherwise. */
export function parseLength(hours: string, minutes: string): number | null | 'invalid' {
  const h = hours.trim();
  const m = minutes.trim();
  if (h === '' && m === '') return null;
  const hn = h === '' ? 0 : Number(h);
  const mn = m === '' ? 0 : Number(m);
  if (!Number.isInteger(hn) || !Number.isInteger(mn) || hn < 0 || mn < 0 || mn > 59) return 'invalid';
  const seconds = hn * 3600 + mn * 60;
  return seconds > 0 ? seconds : 'invalid';
}

/** Whole seconds → the hours and minutes the inputs show. */
export function splitLength(value: unknown): { hours: string; minutes: string } {
  if (typeof value !== 'number' || value <= 0) return { hours: '', minutes: '' };
  return { hours: String(Math.floor(value / 3600)), minutes: String(Math.round((value % 3600) / 60)) };
}
